import React from "react";
import classes from "./Button.module.css";

// Variants
// primary, secondary, transparent,  silver, secondary-outlined
const Button = ({
  label,
  type,
  customStyle,
  onClick,
  disabled = false,
  children,
  leftIcon,
  rightIcon,
  labelClass,
  className = "",
  variant,
  ...props
}) => {
  return (
    <>
      <button
        type={type}
        style={customStyle && customStyle}
        onClick={onClick}
        disabled={disabled}
        color-variant={variant}
        className={` ${classes.btn} ${className} `}
        {...props}
      >
        {leftIcon && leftIcon}
        {label && <label className={labelClass}>{label}</label>}
        {children && <>{children}</>}
        {rightIcon && rightIcon}
      </button>
    </>
  );
};

export default Button;
